
const Footer = ()=>{
    return(
      <footer>
        <div className="container">
          <p>© Copyright 2025 Tasty Takeaway. All Rights Reserved</p>
          <small> Made by Aanchal Manocha</small>
        </div>
      </footer>
    );

  };
  export default Footer;